import {inject, Injectable} from "@angular/core";
import {MediaViewerComponent} from "../../libs/media/media-viewer/media-viewer.component";
import {MediaDto} from "../../repositories/dto/media.dto";
import {InvoiceDto} from "../../repositories/dto/document/invoice.dto";
import {isDefined} from "../../libs/utils/epic.utils";
import {SubInvoiceDto} from "../../repositories/dto/sub-invoice.dto";
import {HttpResponse} from "@angular/common/http";
import {LoggingService} from "../logger/logging.service";

@Injectable({providedIn: 'root'})
export class MediaViewerService {

  private readonly log: LoggingService = inject(LoggingService);

  // Component is added once globally in the AppComponent
  private mediaViewer: MediaViewerComponent | undefined;

  public setMediaViewer(mediaViewer: MediaViewerComponent): void {
    this.mediaViewer = mediaViewer;
  }

  public isContentTypeSupported(contentType: string | undefined): boolean {
    return isDefined(this.mediaViewer) && isDefined(contentType) && this.mediaViewer.isContentTypeSupported(contentType);
  }

  public async open(media: string | MediaDto, invoice?: InvoiceDto, subInvoice?: SubInvoiceDto): Promise<boolean> {
    if (isDefined(this.mediaViewer)) {
      return this.mediaViewer.open(media, invoice, subInvoice);
    }
    this.log.warn('MediaViewerService.open() called without MediaViewerComponent: {}', [media]);
    return Promise.resolve(false);
  }

  public openForResponse(res: HttpResponse<Blob>): Promise<boolean> {
    if (isDefined(this.mediaViewer)) {
      return this.mediaViewer.openForResponse(res);
    }
    this.log.warn('MediaViewerService.openForResponse() called without MediaViewerComponent: {}', [res]);
    return Promise.resolve(false);
  }

  public async openInvoicePreview(invoice: InvoiceDto): Promise<boolean> {
    if (isDefined(this.mediaViewer)) {
      return this.mediaViewer.openInvoicePreview(invoice.id);
    }
    this.log.warn('MediaViewerService.openInvoicePreview() called without MediaViewerComponent: {}', [invoice]);
    return Promise.resolve(false);
  }

  public close(): void {
    if (this.mediaViewer?.isOpen()) {
      this.mediaViewer.close();
    }
  }
}
